import React from "react";

function Footer() {
  return (
    <footer className="mt-12 border-t bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex items-center justify-center">
        <p className="text-sm text-gray-600">© {new Date().getFullYear()} ChauShin Portfolio</p>
      </div>
    </footer>
  );
}

export default Footer;
